import { SGBC_STAFF_MEMBERSHIP_STATISTICS_SET_STAT } from '../../../constants/actionTypesStaffMembershipStatistics';

export function membershipStatisticsSetStat(selectedStat) {
    return {
        type: SGBC_STAFF_MEMBERSHIP_STATISTICS_SET_STAT,
        selectedStat,
    };
}
